import React, { useState, useEffect } from "react";
import { useHistory ,useLocation,useParams, Link} from "react-router-dom";
import { useStore } from "react-redux";
import { useRtoaster } from "../../hooks/useRtoaster";

import { apiKeyCheck, golfLoginApi, guestLoginApi, ssoLogin, versionGetApi, getEnvParam } from "../../const/";
import constant from "../../const/Const";
import { BlackCheckBox } from "../atoms/blackCheckBox";
import { Label } from "../atoms/label";
import { ButtonLinkForm } from "../molecules/buttonLinkForm";
import { LabelButtonForm } from "../molecules/labelButtonForm";
import { useMedia } from "use-media";
import { LabelInputForm } from "../molecules/labelInputForm";
import JPG from "../../resources/image/golf_bg_000.jpg";
import "../../../src/index.css";
import User from "../../User.js";
import common from "../../resources/js/common/common"



export const GolfLoginContainer = (props) => {
  const [id, setId] = useState("");
  const [pass, setPass] = useState("");
  const [errorflg, setErrorFlg] = useState(false);
  const [errorflg2, setErrorFlg2] = useState(false);

  const [NotId,setNotId]= useState(false);
  const [NotPass,setNotPass]=useState(false);
  const [WrongIdorPass,setWrongIdorPass]= useState(false);

  //const [zengaku,setHankaku] = useState("");

  const onChangeId = (e) => setId(e.target.value);
  const onChangePass = (e) => setPass(e.target.value);

  //レスポンシブ対応
  const isWidePhone = useMedia({ maxWidth: "480px" });
  const isWideTablet = useMedia({ maxWidth: "960px" });

  // rtoasterタグ生成
  useRtoaster();

  // 初期表示処理
  useEffect(() => {
    
    //バージョンの格納
    common.doPost(versionGetApi, {}, versionCheck);

    //sso対応
    //idとkeyの取得
    var query = window.location.href.split("?")[1];
    if(query){
      var rawParams = query.split('&');
      rawParams.forEach(function(prm,i){
        var kv = prm.split('=');
        params[kv[0]] = kv[1];
      });
    }
    var id = params["ID"];
    var key = params["key"]
    //ssoリクエスト
    if(id != null && key != null){
      common.doPost(ssoLogin, {ID:id,key:key}, ssoCheck);
    }
    

    const loginFlg = User.getLocalStorage("isLoggedIn");
    
    if(loginFlg === "true") { 
      // hashの取得
      const loginHash = store.getState().login.hashAutoLogin;
      if(loginHash != undefined){
        // post送信
        common.doPost(golfLoginApi, { hash:loginHash}, autoLogin);
      }
    }
  }, []);

  const autoLogin = (res) => {
    afterLogin(res);
  }

  //sso処理
  const ssoCheck = (res) => {
    if(res.data.ssoLogin){
      //SSOの場合は会員権情報初期化
      store.dispatch({ type:"KAIINKEN", payload: {kaiinken:[]} });
      afterLogin(res);
    }
  }

  const versionCheck = (res) => {
    if(res.data.version){
      store.dispatch({ type:"VERSION", payload: { version:res.data.version} });
    }
  }


  // ログイン処理
  const history = useHistory();
  const store = useStore();
  const params = useParams();

  // 新規登録
  const signup = () => {
    window.open("https://pointrttg.page.link/3dS","_blank");
  }

  // Rtoaster環境設定値取得後処理
  const afterGetEnvParam = (res) => {
    const data = res.data;
    if (data.resultCode == 0) {
      store.dispatch({ type: "ENV_PARAM", payload: { envParam: data.envParam } });
    }
    const rtccFlg = store.getState().rtccFlg;
    if (rtccFlg) {
      store.dispatch({ type: "RTCC_FLG", payload: { rtccFlg: false } });
      history.push("/reserve/rtcc/reservation");
    } else if (history.location.state && history.location.state.prevRef === 'vacancy') {
      // 空室照会からの遷移の場合、ホテル予約に遷移
      const prevState = history.location.state;
      history.push('/reserve/hotel/search', { prevRef: prevState.prevRef, shisetsuCd: prevState.shisetsuCd, date:prevState.date })
    } else {
      history.push("/reserve/top");
    }
  }

  // ログイン後関数
  const afterLogin = (res) => {

    // 返却値取得
    const data = res.data;

    if (data.resultCode !== constant.RESULT_SUCCESS) {
      setWrongIdorPass(true);
      document.getElementById("golfLoginId").style.backgroundColor = constant.ERROR_COLOR;
      document.getElementById("golfLoginPassword").style.backgroundColor = constant.ERROR_COLOR;
      // ここでpushする意図は不明だが温存
      // 空室照会からの遷移の場合、state引き継いで遷移先情報保持
      if (history.location.state && history.location.state.prevRef === 'vacancy') {
        const prevState = history.location.state;
        history.push("/reserve/login", prevState);
      } else {
        history.push("/reserve/login");
      }
    } else {
      // 遷移先フラグの取得
      // ログイン情報の取得
      const apiKey = data.apiKey;
      const userNumber = data.userNumber;
      const loginUserInfo = data.loginUserInfo;
      const memberInfo = data.memberInfo;
      const memberCode = data.memberCode;
      const hashAutoLogin = data.hashAutoLogin;
      const resvKaiinken = data.resvKaiinken;
      const loginKey = data.loginKey;
      const loginType = data.loginType;
      setId(loginKey);
      // ログイン情報の保持
      store.dispatch({
        type:"LOGIN",
        payload: {
          apiKey:apiKey, 
          userNumber:userNumber, 
          loginUserInfo:loginUserInfo, 
          memberCode:memberCode, 
          hashAutoLogin:hashAutoLogin,
          memberInfo:memberInfo,
          userId:loginKey,
          loginType:loginType
        }
      });
      // Rtoaster環境設定値取得
      common.doPost(getEnvParam, { pointKaiinId: memberCode }, afterGetEnvParam);

      // 会員制の日付跨ぎチェック用フラグの初期化
      store.dispatch({ type: "OVERNIGHT_FLG", payload: { overnightFlg: false } });
      store.dispatch({ type: "MEMBERSHIP_RESV_START_DATE", payload: { membershipResvStartDate: "" } })
      //resvKaiinkenリダックスにselected追加処理書く
      let resvkaiin = setResvKaiinken(resvKaiinken);
      store.dispatch({type:"RESV_KAIINKEN", payload: {resvKaiinken: resvkaiin} });
      User.loginData();
    }

  }

  //ログインボタン押下時処理
  const onClickGuestLogin = () => {

    //version以外のstoreをクリア
    store.dispatch({ type: "LOGIN", payload: { apiKey: undefined, userNumber: undefined, loginUserInfo: undefined, memberCode: undefined, hashAutoLogin: undefined, memberInfo: undefined, userId: undefined, resvKaiinken: undefined } });
    store.dispatch({ type: "COURSE", payload: { course: [] } });
    store.dispatch({ type: "SET_COURSE_NAMES", payload: { courseNames: [] } });
    store.dispatch({ type: "DETAIL_CONDITION", payload: { detailCondition: [] } });
    store.dispatch({ type: "SET_FACILITY", payload: { facility: [] } });
    store.dispatch({ type: "FAVORITE_CONDITION", payload: { favoriteCondition: [] } });
    store.dispatch({ type: "GROUP", payload: { group: [] } });
    store.dispatch({ type: "ADD_INPUT_PLAYER_INFO", payload: { inputPlayerInfo: [] } });
    store.dispatch({ type: "SET_PLAN", payload: { plan: [] } });
    store.dispatch({ type: "SELECT_PLAY_DATE1", payload: { playDate1: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 3) } });
    store.dispatch({ type: "SELECT_PLAY_DATE2", payload: { playDate2: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 3) } });
    store.dispatch({ type: "ADD_RESERVER", payload: { reserver: [] } });
    store.dispatch({ type: "RESERVE_TYPE", payload: { reserveType: [] } });
    store.dispatch({ type: "SEARCH_RESULT", payload: [] });
    store.dispatch({ type: "START_TIME", payload: { startTime: [] } });
    store.dispatch({ type: "ADD_TEETIME_LIST", payload: { teeTimeList: [] } });
    store.dispatch({ type: "VIEWINFO", payload: { viewinfo: [] } });
    store.dispatch({ type: "KAIINKEN", payload: { kaiinken: [] } });

    // post送信
    common.doPost(guestLoginApi, {}, afterLogin);
  };

  //会員制の会員権リダックスオブジェクト生成
  const setResvKaiinken = (resv) => {
    let resvList = [];
    resv.map((val)=>{
      val["selected"] = false;
      resvList.push(val);
    })
    resvList[0].selected = true;
    return resvList;
  }

  //ログインボタン押下時処理
  const onClickLogin = (e) => {

    //version以外のstoreをクリア
    store.dispatch({ 
      type:"LOGIN", 
      payload: {
        apiKey:undefined, 
        userNumber:undefined, 
        loginUserInfo:undefined, 
        memberCode:undefined, 
        hashAutoLogin:undefined, 
        memberInfo:undefined, 
        userId:undefined, 
        resvKaiinken: undefined,
        loginType: undefined
      }
    });
    store.dispatch({ type:"COURSE", payload: {course:[]} });
    store.dispatch({ type:"SET_COURSE_NAMES", payload: {courseNames:[]} });
    store.dispatch({ type:"DETAIL_CONDITION", payload: {detailCondition:[]} });
    store.dispatch({ type:"SET_FACILITY", payload: {facility:[]} });
    store.dispatch({ type:"FAVORITE_CONDITION", payload: {favoriteCondition:[]} });
    store.dispatch({ type:"GROUP", payload: {group:[]} });
    store.dispatch({ type:"ADD_INPUT_PLAYER_INFO", payload: {inputPlayerInfo:[]} });
    store.dispatch({ type:"SET_PLAN", payload: {plan:[]} });
    store.dispatch({ type:"SELECT_PLAY_DATE1", payload: {playDate1: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 3) }});
    store.dispatch({ type:"SELECT_PLAY_DATE2", payload: {playDate2: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 3) }});
    store.dispatch({ type:"ADD_RESERVER", payload: {reserver:[]} });
    store.dispatch({ type:"RESERVE_TYPE", payload: {reserveType:[]} });
    store.dispatch({ type:"SEARCH_RESULT", payload: [] });
    store.dispatch({ type:"START_TIME", payload: {startTime:[]} });
    store.dispatch({ type:"ADD_TEETIME_LIST", payload: {teeTimeList:[]} });
    store.dispatch({ type:"VIEWINFO", payload: {viewinfo:[]} });
    store.dispatch({ type:"KAIINKEN", payload: {kaiinken:[]} });
    store.dispatch({ type:"GOLF_RESERVATION_CEHCK", payload: {golfReservationCheck:{}} });
    store.dispatch({ type:"GOLF_RESERVATION_SEARCH", payload: {golfReservationSearch:{search:[],target:[]}} });
    store.dispatch({ type:"GOLF_RESERVATION_LIST", payload: {golfReservationList:[]} });


    // Enterキー時用
    e.preventDefault();

    // 要素取得
    const loginIdElem = document.getElementById("golfLoginId");
    const passwordElem = document.getElementById("golfLoginPassword");

    // エラー表示クリア
    loginIdElem.style.backgroundColor = "";
    passwordElem.style.backgroundColor = "";

    let failedFlg = false;

    // 必須項目入力チェック
    if (id !== "") {
      setNotId(false);
    } 
    else {
      failedFlg = true;
      setNotId(true);
      loginIdElem.style.backgroundColor = constant.ERROR_COLOR
    }
    if (pass !== "") {
      setNotPass(false);
    } 
    else {
      failedFlg = true;
      setNotPass(true);
      passwordElem.style.backgroundColor = constant.ERROR_COLOR
    }

    const reg = new RegExp("^[a-zA-Z0-9@!#$%&’*+-/=?^_`{|}~\.]*$");

    // ログインID文字種&長さ、パスワード長さチェック
    if (reg.test(id) || id.length <= 256 || pass.length <= 14) {
      setWrongIdorPass(false);
    }
    else {
      failedFlg = true;
      setWrongIdorPass(true);
      loginIdElem.style.backgroundColor = constant.ERROR_COLOR
      passwordElem.style.backgroundColor = constant.ERROR_COLOR
    }

    if (failedFlg) {
      return;
    }

    // post送信
    const loginSaveFlg = document.getElementById("autoLogin").checked;
    common.doPost(golfLoginApi, { loginKey:id, password:pass,nextAutoLogin:loginSaveFlg}, afterLogin);
  };


  return (
    <div style={isWideTablet ? styles.loginWrapSp : styles.loginWrapPc}>
      <div style={isWideTablet ? styles.loginBaseSp : styles.loginBasePc}>
        <div style={isWideTablet ? styles.wrapperSp : styles.wrapperPc}>
          <div style={NotId ? {display: "block" ,color:"red" ,textAlign:"center",fontSize:"0.8rem",background: "rgba(255,255,255,0)",border: 0,fontWeight:"bold"}: {display: "none"}} > ログインIDを入力してください</div>  
          <div style={NotPass ? {display: "block" ,color:"red" ,textAlign:"center",fontSize:"0.8rem",background: "rgba(255,255,255,0)",border: 0,fontWeight:"bold"}: {display: "none"}} > パスワードを入力してください</div>       
          <div style={WrongIdorPass ? {display: "block" ,color:"red" ,textAlign:"center",fontSize:"0.8rem",background: "rgba(255,255,255,0)",border: 0,fontWeight:"bold"}: {display: "none"}} >ログインIDまたはパスワードに誤りがあります</div>

          <form>
            <div style={isWideTablet ? styles.containerSp : styles.containerPc}>
              <div style={isWideTablet ? styles.contentsLeftSp : styles.contentsLeftPc}>

                <LabelInputForm
                  label={"RTTGポイントクラブのメールアドレス または ポイント会員ID"}
                  type={"id"}
                  id="golfLoginId"
                  style={isWideTablet ? styles.categoryLabelSp : styles.categoryLabelPc}
                  placeholder="メールアドレス または 会員ID"
                  style2={isWideTablet ? (errorflg ? styles.inputErrorSP : styles.inputSP) :(errorflg ? styles.inputErrorPC : styles.inputPC)}
                  maxLength={"256"}
                  value={id}
                  class="test"
                  onChange={onChangeId}
                />

                <LabelInputForm
                  label={"パスワード"}
                  type={"password"}
                  id="golfLoginPassword"
                  maxLength={"14"}
                  style={isWideTablet ? styles.categoryLabelSp : styles.categoryLabelPc}
                  placeholder="パスワードを入力"
                  style2={isWideTablet ? (errorflg2 ? styles.inputErrorSP : styles.inputSP) : (errorflg2 ? styles.inputErrorPC : styles.inputPC)}
                  value={pass}
                  class="test"
                  onChange={onChangePass}
                />

                <BlackCheckBox
                  checkAreaStyle={isWideTablet ? styles.playCheckAreaSp : styles.playCheckAreaPC}
                  id={"autoLogin"}
                  item={"次回以降自動的にログインする"} 
                />

                <ButtonLinkForm
                  buttonText={"ログイン"}
                  href={"https://point.rttg.jp/web/login/forgot_password"}
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                  linkTitle={"パスワードをお忘れですか？"}
                  onClick={onClickLogin}
                  isWideTablet={isWideTablet}
                />
                
                {/* <Link onClick={onClickGuestLogin} style={isWideTablet ? styles.guestLoginLinkSp : styles.guestLoginLinkPc}> ログインせずに進む </Link> */}

                <div
                  style={isWideTablet ? styles.lineStyle : null}>
                </div>
              </div>
              <div
                style={isWideTablet ? styles.contentsRightSp : styles.contentsRightPc}>
                <LabelButtonForm
                  label="RTTGポイントクラブへの登録がお済みではない方はこちら"
                  buttonText={"新規ご登録"}
                  onClick={signup}
                  isWideTablet={isWideTablet}
                />

                {/* ログインせずに予約は9末時点では非表示 */}
                <Label
                  label="※会員制施設の利用にはログイン、会員登録が必要です"
                  style={isWideTablet ? styles.attentionSp : styles.attentionPc}
                />
              </div>
            </div>
          </form>
        </div>
        <Label
          label="COPYRIGHT © RESORTTRUST ALL RIGHTS RESERVED"
          style={isWideTablet ? styles.footerLabelSp : styles.footerLabelPc}
        />
      </div>
    </div>
  );
};

const styles = {

  guestLoginLinkPc: {
    color: "#000",
    fontSize: "0.7rem",
    textDecoration: "none",
    margin: "5% 0 6.5% 20%",
    borderBottom: "1px solid #000"
  },

  guestLoginLinkSp: {
    fontSize: "small",
    textDecoration: "underline"
  },

  loginWrapPc: {
    height: "100vh",
    overflow: "hidden",
  },
  loginWrapSp: {

  },
  loginBasePc: {
    width: "100%",
    paddingTop: "25px",
    paddingBottom: "43%",
    // backgroundColor: "white",
    // backgroundImage: `url(${JPG})`,
    backgroundAttachment: "fixed",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "100vh",
  },
  
  loginBaseSp: {
    // backgroundImage: `url(${JPG})`,
    backgroundSize: '120% 104%',
    backgroundRepeat: "no-repeat",
    margin: "0 auto",
    textAlign: "center",
    width: "100%",
    height: "calc(100vh + 8rem)",
    position: "relative"
  },

  wrapperSp: {
    margin: "0px auto auto",
    textAlign: "center",
    width: "90%",
    height: "auto",
    padding: "2rem 0rem",
    overflowX: "hidden",
  },

  wrapperPc: {
    position: "absolute",
    top: "30%",
    left: "17%",
    width: "66%",
    margin: "0 auto",
    padding: "3% 0px 3% 0",
    // backgroundColor: "#ffffff",
    background: "rgba(255,255,255,0.9)",
  },

  containerSp: {
    background: "rgba(255,255,255,0.9)",
    padding: "0px 1rem",
  },

  containerPc: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    //background: "rgba(255,255,255,0.9)",
  },

  contentsLeftSp: {

  },

  contentsLeftPc: {
    width: "40%",
    marginLeft: "5%",
    textAlign: "left",
  },

  contentsRightPc: {
    width: "40%",
    textAlign: "left",
    borderLeft: "1px solid #dddddd",
    marginRight: "10%",
  },

  inputPC: {
    textAlign: "left",
    margin: "0% 0px 4% 20%",
    height: "2rem",
    width: "70%",
    maxWidth: "25rem",
    fontSize: "0.5rem",
    border: "solid 1px #b7b7b7",
    padding: "2px 5%",
    fontSize: "0.8rem",
    lineHeight: "1.5em",
    textOverflow: "ellipsis",
  },

  inputErrorPC: {
    textAlign: "left",
    margin: "0% 0px 4% 20%",
    height: "2rem",
    width: "70%",
    maxWidth: "25rem",
    fontSize: "0.5rem",
    backgroundColor: "#ffebeb",
    border: "solid 1px red",
    padding: "2px 5%",
    fontSize: "0.7rem",
    lineHeight: "1.5em",
  },

  inputSP: {
    textAlign: "left",
    margin: "0.5rem 0rem 0rem 5%",
    height: "2.5rem",
    width: "80%",
    maxWidth: "40rem",
    border: "solid 1px #b7b7b7",
    padding: "2px 5%",
    fontSize: "small",
    lineHeight: "1.5em",
    letterSpacing: "0.1rem",
  },
  inputErrorSP: {
    textAlign: "left",
    margin: "0.5rem 0rem 0rem 5%",
    height: "2.5rem",
    width: "80%",
    maxWidth: "40rem",
    border: "solid 1px red",
    backgroundColor: "#ffebeb",
    padding: "2px 5%",
    fontSize: "small",
    lineHeight: "1.5em",
    letterSpacing: "0.1rem",
  },

  playCheckAreaPC: {
    cursor: "pointer",
    width: "80%",
    textAlign: "left",
    margin: "0rem 0rem 1rem 20%",
    letterSpacing: "0.1rem",
    fontSize: "0.7rem ",
    color: "#4a4949",
  },

  playCheckAreaSp: {
    cursor: "pointer",
    width: "80%",
    textAlign: "center",
    margin: "1rem 0rem 0rem 2rem",
    fontSize: "0.8em",
  },

  categoryLabelSp: {
    padding: "1.5rem 0rem 0rem 0rem",
    fontSize: "0.8rem",
    width: "90%",
    marginLeft: "5%",
    color: "#9c9d9f",
    fontWeight: "600",
  },

  categoryLabelPc: {
    padding: "0% 0rem 1% 20%",
    fontSize: "0.8rem",
    color: "#9c9d9f",
    fontWeight: "600",
  },

  checkLabelSp: {
    fontSize: "small",
  },

  checkLabelPc: {
    textAlign: "left",
    fontSize: "small",
    fontSize: "0.7rem",
  },

  attentionSp: {
    padding: "1.5rem 0rem 1.5rem 1rem",
    color: "gray",
    fontSize: "0.77rem",
    width: "calc(100% - 2rem)"
  },

  attentionPc: {
    margin: "18% 0% 0% 10%",
    fontSize: "0.7rem",
    color: "#acabb0",
    width: "80%",
  },

  label11: {
    padding: "1em 0em 0em",
    fontSize: "0.8rem",
  },

  label12: {
    color: "white",
    textAlign: "center",
    padding: "0.5rem 2rem",
    fontSize: "1rem",
  },

  link3: {
    color: "gray",
    fontSize: "1.2rem",
    textDecoration: "underline",
  },

  link4: {
    color: "brack",
    fontSize: "1.2rem",
    textDecoration: "underline",
    padding: "0rem 2rem",
  },

  lineStyle: {
    padding: "1rem 0rem",
    borderBottom: "2px solid #ccc",
  },

  footerLabelSp: {
    position: "absolute",
    color: "gray",
    fontSize: "0.75rem",
    fontSize: "small",
    textAlign: "center",
    width: "100%",
    paddingBottom: "10px",
    bottom: "10px",
  },

  footerLabelPc: {
    position: "absolute",
    textAlign: "center",
    width: "100%",
    color: "gray",
    fontSize: "small",
    marginTop: "20px",
    bottom: "10px",
  },

};
